import React, { useState, useEffect, useRef } from "react";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from "../components/ConfirmationDialogRaw";
import { downloadCsv } from "../common/sharedFunctions";
import {
  Grid,
  Typography,
  Modal,
  Button,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Avatar,
} from "@mui/material";
import { api } from "common";
import UsersCombo from "../components/UsersCombo";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import PaymentGatewayModal from "../components/PaymentGatewayModal";
import { useNavigate } from "react-router-dom";
import {
  BidModal,
  acceptBid,
  showEst,
} from "../common/sharedFunctions";
import moment from "moment";

// Icons for layout
import GridViewIcon from '@mui/icons-material/GridView';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import UpdateIcon from '@mui/icons-material/Update';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 680,
    maxWidth: "95%",
    backgroundColor: "var(--bg-card)",
    border: "var(--card-border)",
    borderRadius: "16px",
    boxShadow: "var(--shadow)",
    padding: "28px",
    outline: "none",
    color: "var(--text-main)",
  },
}));

const icons = {
  paypal: require("../assets/payment-icons/paypal-logo.png").default,
  braintree: require("../assets/payment-icons/braintree-logo.png").default,
  stripe: require("../assets/payment-icons/stripe-logo.png").default,
  paytm: require("../assets/payment-icons/paytm-logo.png").default,
  payulatam: require("../assets/payment-icons/payulatam-logo.png").default,
  flutterwave: require("../assets/payment-icons/flutterwave-logo.png").default,
  paystack: require("../assets/payment-icons/paystack-logo.png").default,
  securepay: require("../assets/payment-icons/securepay-logo.png").default,
  payfast: require("../assets/payment-icons/payfast-logo.png").default,
  liqpay: require("../assets/payment-icons/liqpay-logo.png").default,
  culqi: require("../assets/payment-icons/culqi-logo.png").default,
  mercadopago: require("../assets/payment-icons/mercadopago-logo.png").default,
  squareup: require("../assets/payment-icons/squareup-logo.png").default,
  wipay: require("../assets/payment-icons/wipay-logo.png").default,
  test: require("../assets/payment-icons/test-logo.png").default,
  razorpay: require("../assets/payment-icons/razorpay-logo.png").default,
  paymongo: require("../assets/payment-icons/paymongo-logo.png").default,
  skipcash: require("../assets/payment-icons/skipcash-logo.png").default,
};

const BookingHistory = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { cancelBooking, updateBooking, RequestPushMsg, forceEndBooking, acceptTask, cancelTask } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const userdata = useSelector((state) => state.usersdata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const role = useSelector((state) => state.auth.profile.usertype);
  const taskdata = useSelector((state) => state.taskdata);
  const tasks = taskdata && taskdata.tasks ? taskdata.tasks : [];
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  let providers = useSelector((state) => state.paymentmethods.providers);
  if (providers && !Array.isArray(providers)) {
    let arr = [];
    let pms = Object.keys(providers);
    for (let i = 0; i < pms.length; i++) {
      if (providers[pms[i]].active) {
        arr.push({
          name: pms[i],
          link: '/' + pms[i] + '-link',
          ...providers[pms[i]]
        });
      }
    }
    providers = arr;
  }
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const [users, setUsers] = useState(null);
  const [userCombo, setUserCombo] = useState(null);
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const [bidModalStatus, setBidModalStatus] = useState(false);
  const [selectedBidder, setSelectedBidder] = useState();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const classes = useStyles();
  const [walletModalStatus, setWalletModalStatus] = useState(false);



  // New UI states
  const [layoutMode, setLayoutMode] = useState(role === 'admin' || role === 'fleetadmin' ? 'list' : 'grid');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Fallback Translator Helper
  const trans = (key, fallback) => {
    const val = t(key);
    return val === key ? fallback : val;
  };

  useEffect(() => {
    if (bookinglistdata.bookings) {
      // Sort bookings descending by date so newest trips appear first
      const sorted = [...bookinglistdata.bookings].sort((a, b) => {
        return new Date(b.bookingDate || 0) - new Date(a.bookingDate || 0);
      });
      setData(sorted);
    } else {
      setData([]);
    }
  }, [bookinglistdata.bookings]);

  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (
          user.usertype === "driver" &&
          ((user.fleetadmin === auth.profile.uid && role === "fleetadmin") ||
            role === "admin")
        ) {
          arr.push({
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            uid: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin
                ? user.mobile
                : t("hidden_demo")) +
              ") " +
              (settings.AllowCriticalEditsAdmin
                ? user.email
                : t("hidden_demo")),
            pushToken: user.pushToken ? user.pushToken : "",
            carType: user.carType,
          });
        }
      }
      setUsers(arr);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    auth.profile.uid,
    role,
    t,
  ]);

  const assignDriver = () => {
    let booking = data[rowIndex];
    if (booking["requestedDrivers"]) {
      booking["requestedDrivers"][userCombo.uid] = true;
    } else {
      booking["requestedDrivers"] = {};
      booking["requestedDrivers"][userCombo.uid] = true;
    }
    dispatch(updateBooking(booking));
    RequestPushMsg(userCombo.pushToken, {
      title: t("notification_title"),
      msg: t("new_booking_notification"),
      screen: "DriverTrips",
      channelId: settings.CarHornRepeat ? "bookings-repeat" : "bookings",
    });
    setUserCombo(null);
    handleClose();
    alert("Driver assigned successfully and notified.");
  };

  const onConfirmClose = (value) => {
    if (value) {
      dispatch(
        cancelBooking({
          reason: value,
          booking: selectedBooking,
          cancelledBy: role,
        })
      );
    }
    setOpenConfirm(false);
  };

  const handleChange = (e) => {
    if (e.target.name === "selectedProviderIndex") {
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }
    if (e.target.name === "selectedBidder") {
      setSelectedBidder(e.target.value);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePaymentModalClose = (e) => {
    setTimeout(() => {
      setPaymentModalStatus(false);
    }, 1500);
  };

  const handleWalletModalClose = (e) => {
    setTimeout(() => {
      setWalletModalStatus(false);
    }, 1500);
  };

  useEffect(() => {
    if (providers) {
      setSelectedProvider(providers[0]);
    }
  }, [providers]);

  const processPayment = (rowData) => {
    const curBooking = rowData;
    if (curBooking.payment_mode === "card") {
      let paymentCost = curBooking.selectedBid
        ? curBooking.selectedBid.trip_cost
        : curBooking.trip_cost;
      const paymentPacket = {
        payment_mode: "card",
        customer_paid: parseFloat(paymentCost).toFixed(settings.decimal),
        cardPaymentAmount: parseFloat(paymentCost).toFixed(settings.decimal),
        discount: 0,
        usedWalletMoney: 0,
        cashPaymentAmount: 0,
        promo_applied: false,
        promo_details: null,
        payableAmount: parseFloat(paymentCost).toFixed(settings.decimal),
      };
      curBooking.paymentPacket = paymentPacket;
      dispatch(updateBooking(curBooking));
      setSelectedBooking(curBooking);
      setPaymentModalStatus(true);
    }
    if (curBooking.payment_mode === "wallet") {
      let curBooking = { ...rowData };
      if (rowData.status === "PAYMENT_PENDING") {
        curBooking.status = "NEW";
        curBooking.prepaid = true;
      } else if (rowData.status === "PENDING") {
        curBooking.status = "PAID";
      } else if (rowData.status === "NEW") {
        curBooking.prepaid = true;
        curBooking.status = "ACCEPTED";
      }

      curBooking.customer_paid =
        curBooking.status === "ACCEPTED"
          ? 0
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney =
        curBooking.status === "ACCEPTED"
          ? 0
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount =
        curBooking.status === "ACCEPTED"
          ? parseFloat(curBooking.selectedBid.trip_cost).toFixed(
            settings.decimal
          )
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);

      if (curBooking.status === "ACCEPTED") {
        curBooking.driver = curBooking.selectedBid.driver;
        curBooking.driver_image = curBooking.selectedBid.driver_image;
        curBooking.driver_name = curBooking.selectedBid.driver_name;
        curBooking.driver_contact = curBooking.selectedBid.driver_contact;
        curBooking.driver_token = curBooking.selectedBid.driver_token;
        curBooking.vehicle_number = curBooking.selectedBid.vehicle_number;
        curBooking.vehicleModel = curBooking.selectedBid.vehicleModel;
        curBooking.vehicleMake = curBooking.selectedBid.vehicleMake;
        curBooking.driverRating = curBooking.selectedBid.driverRating;
        curBooking.trip_cost = curBooking.selectedBid.trip_cost;
        curBooking.convenience_fees = curBooking.selectedBid.convenience_fees;
        curBooking.driver_share = curBooking.selectedBid.driver_share;
        curBooking.fleetadmin = curBooking.selectedBid.fleetadmin ? curBooking.selectedBid.fleetadmin : null;
        curBooking.fleetCommission = curBooking.selectedBid.fleetadmin ? ((parseFloat(curBooking.selectedBid.trip_cost) - parseFloat(curBooking.selectedBid.convenience_fees)) * (parseFloat(curBooking.fleet_admin_comission) / 100)).toFixed(2) : null;
        curBooking.driverOffers = {};
        curBooking.requestedDrivers = {};
        curBooking.driverEstimates = {};
        curBooking.selectedBid = {};
      }
      dispatch(updateBooking(curBooking));

      setBidModalStatus(false);
    }
    if (curBooking.payment_mode === "cash") {
      let curBooking = { ...rowData };
      if (rowData.status === "PAYMENT_PENDING") {
        curBooking.status = "NEW";
      } else if (rowData.status === "PENDING") {
        curBooking.status = "PAID";
      } else if (rowData.status === "NEW") {
        curBooking.status = "ACCEPTED";
      }

      curBooking.customer_paid =
        curBooking.status === "ACCEPTED"
          ? 0
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = 0;
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount =
        curBooking.status === "ACCEPTED"
          ? 0
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.payableAmount =
        curBooking.status === "ACCEPTED"
          ? parseFloat(curBooking.selectedBid.trip_cost).toFixed(
            settings.decimal
          )
          : parseFloat(curBooking.trip_cost).toFixed(settings.decimal);

      if (curBooking.status === "ACCEPTED") {
        curBooking.driver = curBooking.selectedBid.driver;
        curBooking.driver_image = curBooking.selectedBid.driver_image;
        curBooking.driver_name = curBooking.selectedBid.driver_name;
        curBooking.driver_contact = curBooking.selectedBid.driver_contact;
        curBooking.driver_token = curBooking.selectedBid.driver_token;
        curBooking.vehicle_number = curBooking.selectedBid.vehicle_number;
        curBooking.vehicleModel = curBooking.selectedBid.vehicleModel;
        curBooking.vehicleMake = curBooking.selectedBid.vehicleMake;
        curBooking.driverRating = curBooking.selectedBid.driverRating;
        curBooking.trip_cost = curBooking.selectedBid.trip_cost;
        curBooking.convenience_fees = curBooking.selectedBid.convenience_fees;
        curBooking.driver_share = curBooking.selectedBid.driver_share;
        curBooking.fleetadmin = curBooking.selectedBid.fleetadmin ? curBooking.selectedBid.fleetadmin : null;
        curBooking.fleetCommission = curBooking.selectedBid.fleetadmin ? ((parseFloat(curBooking.selectedBid.trip_cost) - parseFloat(curBooking.selectedBid.convenience_fees)) * parseFloat(curBooking.fleet_admin_comission) / 100).toFixed(2) : null;
        curBooking.driverOffers = {};
        curBooking.requestedDrivers = {};
        curBooking.driverEstimates = {};
        curBooking.selectedBid = {};
      }
      dispatch(updateBooking(curBooking));
      setBidModalStatus(false);
    }
  };

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...selectedBooking };
    let paymentCost = curBooking.selectedBid
      ? curBooking.selectedBid.trip_cost
      : curBooking.trip_cost;
    if (parseFloat(paymentCost) > parseFloat(auth.profile.walletBalance)) {
      setCommonAlert({ open: true, msg: t("wallet_balance_low") });
    } else {
      curBooking.prepaid =
        curBooking.status === "NEW" || curBooking.status === "PAYMENT_PENDING"
          ? true
          : false;
      curBooking.status = curBooking.status === "NEW" ? "ACCEPTED" : "PAID";
      curBooking.customer_paid = parseFloat(paymentCost).toFixed(
        settings.decimal
      );
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(paymentCost).toFixed(
        settings.decimal
      );
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.promo_applied = false;
      curBooking.promo_details = null;
      curBooking.paymentPacket = null;
      curBooking.driver = curBooking.selectedBid
        ? curBooking.selectedBid.driver
        : curBooking.driver;
      curBooking.driver_image = curBooking.selectedBid
        ? curBooking.selectedBid.driver_image
        : curBooking.driver_image;
      curBooking.driver_name = curBooking.selectedBid
        ? curBooking.selectedBid.driver_name
        : curBooking.driver_name;
      curBooking.driver_contact = curBooking.selectedBid
        ? curBooking.selectedBid.driver_contact
        : curBooking.driver_contact;
      curBooking.driver_token = curBooking.selectedBid
        ? curBooking.selectedBid.driver_token
        : curBooking.driver_token;
      curBooking.vehicle_number = curBooking.selectedBid
        ? curBooking.selectedBid.vehicle_number
        : curBooking.vehicle_number;
      curBooking.vehicleModel = curBooking.selectedBid
        ? curBooking.selectedBid.vehicleModel
        : curBooking.vehicleModel;
      curBooking.vehicleMake = curBooking.selectedBid
        ? curBooking.selectedBid.vehicleModel
        : curBooking.vehicleModel;
      curBooking.driverRating = curBooking.selectedBid
        ? curBooking.selectedBid.driverRating
        : curBooking.driverRating;
      curBooking.trip_cost = curBooking.selectedBid
        ? curBooking.selectedBid.trip_cost
        : curBooking.trip_cost;
      curBooking.convenience_fees = curBooking.selectedBid
        ? curBooking.selectedBid.convenience_fees
        : curBooking.convenience_fees;
      curBooking.driver_share = curBooking.selectedBid
        ? curBooking.selectedBid.driver_share
        : curBooking.driver_share;
      curBooking.driverOffers = null;
      curBooking.requestedDrivers = null;
      curBooking.driverEstimates = null;
      curBooking.selectedBid = null;

      dispatch(updateBooking(curBooking));

      setTimeout(() => {
        setWalletModalStatus(false);
      }, 1500);
    }
  };

  const handleBidModalClose = () => {
    setBidModalStatus(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  // Status Filter Group Mapper
  const getStatusGroup = (status) => {
    if (['NEW', 'ACCEPTED', 'PENDING', 'PAYMENT_PENDING'].includes(status)) return 'new';
    if (['ARRIVED', 'STARTED'].includes(status)) return 'active';
    if (['COMPLETE', 'PAID'].includes(status)) return 'completed';
    if (['CANCELLED'].includes(status)) return 'cancelled';
    return 'other';
  };

  const getStatusDetails = (status) => {
    switch (status) {
      case 'NEW':
      case 'ACCEPTED':
        return {
          bg: 'rgba(139, 92, 246, 0.12)',
          color: '#8b5cf6',
          label: trans('NEW', 'New / Accepted')
        };
      case 'ARRIVED':
      case 'STARTED':
        return {
          bg: 'rgba(59, 130, 246, 0.12)',
          color: '#3b82f6',
          label: status === 'ARRIVED' ? trans('ARRIVED', 'Arrived') : trans('STARTED', 'Started')
        };
      case 'COMPLETE':
        return {
          bg: 'rgba(16, 185, 129, 0.12)',
          color: '#10b981',
          label: trans('COMPLETE', 'Completed')
        };
      case 'PAID':
        return {
          bg: 'rgba(245, 158, 11, 0.12)',
          color: '#f59e0b',
          label: trans('PAID', 'Paid')
        };
      case 'CANCELLED':
        return {
          bg: 'rgba(239, 68, 68, 0.12)',
          color: '#ef4444',
          label: trans('CANCELLED', 'Cancelled')
        };
      case 'PENDING':
      case 'PAYMENT_PENDING':
        return {
          bg: 'rgba(245, 158, 11, 0.12)',
          color: '#f59e0b',
          label: trans('PENDING', 'Payment Pending')
        };
      default:
        return {
          bg: 'rgba(156, 163, 175, 0.12)',
          color: '#9ca3af',
          label: status
        };
    }
  };

  // Handle booking cancellation
  const handleCancelBooking = (booking) => {
    if (
      settings.AllowCriticalEditsAdmin &&
      (role === "customer" ||
        role === "admin" ||
        role === "fleetadmin")
    ) {
      if (booking.status === "NEW" || booking.status === "ACCEPTED") {
        setSelectedBooking(booking);
        setOpenConfirm(true);
      } else {
        setTimeout(() => {
          dispatch(
            cancelBooking({
              reason: t("cancelled_incomplete_booking"),
              booking: booking,
              cancelledBy: role,
            })
          );
        }, 1500);
      }
    } else {
      alert(t("demo_mode"));
    }
  };

  // Filter Bookings Array
  const filteredBookings = data.filter((booking) => {
    // 1. Filter by Active Tab
    if (activeTab !== 'all') {
      if (getStatusGroup(booking.status) !== activeTab) return false;
    }

    // 2. Filter by Search Query
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      const refMatch = booking.reference && booking.reference.toLowerCase().includes(query);
      const pickupMatch = booking.pickupAddress && booking.pickupAddress.toLowerCase().includes(query);
      const dropMatch = booking.dropAddress && booking.dropAddress.toLowerCase().includes(query);
      const carMatch = booking.carType && booking.carType.toLowerCase().includes(query);
      const driverMatch = booking.driver_name && booking.driver_name.toLowerCase().includes(query);
      const customerMatch = booking.customer_name && booking.customer_name.toLowerCase().includes(query);

      return refMatch || pickupMatch || dropMatch || carMatch || driverMatch || customerMatch;
    }

    return true;
  });

  // Pagination bounds
  const totalPages = Math.ceil(filteredBookings.length / pageSize) || 1;
  const currentData = filteredBookings.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return bookinglistdata.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef} className="responsive-container" style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
      
      {/* Upper header action section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <Typography variant="h4" style={{ fontWeight: 700, color: 'var(--text-main)', fontFamily: 'Outfit, sans-serif' }}>
            {t("booking_title")}
          </Typography>
          <Typography variant="body2" style={{ color: 'var(--text-secondary)', marginTop: '4px' }}>
            {trans("manage_and_track_bookings", "Manage, track and view all your ride history.")}
          </Typography>
        </div>
        
        {/* Layout Switch Toggle */}
        <div style={{ display: 'flex', background: 'var(--table-input-bg)', padding: '4px', borderRadius: '10px', border: 'var(--card-border)' }}>
          <Button
            onClick={() => setLayoutMode('grid')}
            variant={layoutMode === 'grid' ? 'contained' : 'text'}
            style={{
              borderRadius: '8px',
              padding: '8px',
              minWidth: '40px',
              height: '40px',
              backgroundColor: layoutMode === 'grid' ? 'var(--primary)' : 'transparent',
              color: layoutMode === 'grid' ? 'white' : 'var(--text-secondary)',
              boxShadow: layoutMode === 'grid' ? '0 4px 12px rgba(72, 127, 255, 0.25)' : 'none',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title={trans("grid_view", "Grid View")}
          >
            <GridViewIcon style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={() => setLayoutMode('list')}
            variant={layoutMode === 'list' ? 'contained' : 'text'}
            style={{
              borderRadius: '8px',
              padding: '8px',
              minWidth: '40px',
              height: '40px',
              backgroundColor: layoutMode === 'list' ? 'var(--primary)' : 'transparent',
              color: layoutMode === 'list' ? 'white' : 'var(--text-secondary)',
              boxShadow: layoutMode === 'list' ? '0 4px 12px rgba(72, 127, 255, 0.25)' : 'none',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title={trans("list_view", "List View")}
          >
            <FormatListBulletedIcon style={{ fontSize: '20px' }} />
          </Button>
        </div>
      </div>

      {/* Summary statistics cards */}
      <Grid container spacing={3} style={{ marginBottom: '24px' }}>
        <Grid item xs={12} sm={6} md={3}>
          <div style={{
            background: 'var(--bg-card)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: 'var(--shadow)',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'rgba(72, 127, 255, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--primary)'
            }}>
              <DirectionsCarIcon />
            </div>
            <div>
              <Typography variant="body2" style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>
                {trans("total_bookings", "Total Bookings")}
              </Typography>
              <Typography variant="h5" style={{ fontWeight: 700, color: 'var(--text-main)', marginTop: '2px' }}>
                {data.length}
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div style={{
            background: 'var(--bg-card)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: 'var(--shadow)',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'rgba(59, 130, 246, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#3b82f6'
            }}>
              <UpdateIcon />
            </div>
            <div>
              <Typography variant="body2" style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>
                {trans("active", "Active")}
              </Typography>
              <Typography variant="h5" style={{ fontWeight: 700, color: 'var(--text-main)', marginTop: '2px' }}>
                {data.filter(b => ['ARRIVED', 'STARTED', 'NEW', 'ACCEPTED', 'PENDING', 'PAYMENT_PENDING'].includes(b.status)).length}
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div style={{
            background: 'var(--bg-card)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: 'var(--shadow)',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'rgba(16, 185, 129, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#10b981'
            }}>
              <CheckCircleIcon />
            </div>
            <div>
              <Typography variant="body2" style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>
                {trans("completed", "Completed")}
              </Typography>
              <Typography variant="h5" style={{ fontWeight: 700, color: 'var(--text-main)', marginTop: '2px' }}>
                {data.filter(b => ['COMPLETE', 'PAID'].includes(b.status)).length}
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div style={{
            background: 'var(--bg-card)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: 'var(--shadow)',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'rgba(239, 68, 68, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#ef4444'
            }}>
              <CancelIcon />
            </div>
            <div>
              <Typography variant="body2" style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>
                {trans("cancelled", "Cancelled")}
              </Typography>
              <Typography variant="h5" style={{ fontWeight: 700, color: 'var(--text-main)', marginTop: '2px' }}>
                {data.filter(b => ['CANCELLED'].includes(b.status)).length}
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* New Ride Requests section for drivers */}
      {role === 'driver' && tasks && tasks.length > 0 && (
        <div style={{
          background: 'var(--bg-card)',
          borderRadius: '16px',
          padding: '24px',
          border: 'var(--card-border)',
          boxShadow: 'var(--shadow)',
          marginTop: '20px',
          marginBottom: '30px'
        }}>
          <Typography variant="h5" style={{ fontWeight: 700, color: 'var(--text-main)', marginBottom: '20px' }}>
            {trans('new_ride_requests', 'New Ride Requests')} ({tasks.length})
          </Typography>
          <Grid container spacing={3}>
            {tasks.map((task) => (
              <Grid item xs={12} md={6} key={task.id}>
                <div style={{
                  padding: '20px',
                  borderRadius: '12px',
                  background: 'var(--bg-main)',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="subtitle2" style={{ color: 'var(--primary)', fontWeight: 600 }}>
                      {task.bookLater ? trans('book_later', 'Book Later') : trans('book_now', 'Book Now')}
                    </Typography>
                    <Typography variant="h6" style={{ color: 'var(--text-main)', fontWeight: 700 }}>
                      {settings.symbol}{task.estimate}
                    </Typography>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <span style={{ minWidth: '8px', height: '8px', borderRadius: '50%', background: '#10b981', marginTop: '6px' }} />
                      <Typography variant="body2" style={{ color: 'var(--text-main)' }}>
                        <strong>{trans('pickup_address', 'Pickup')}:</strong> {task.pickup.add}
                      </Typography>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <span style={{ minWidth: '8px', height: '8px', borderRadius: '50%', background: '#ef4444', marginTop: '6px' }} />
                      <Typography variant="body2" style={{ color: 'var(--text-main)' }}>
                        <strong>{trans('drop_address', 'Drop')}:</strong> {task.drop.add}
                      </Typography>
                    </div>
                  </div>

                  <Typography variant="caption" style={{ color: 'var(--text-secondary)' }}>
                    {trans('booking_time', 'Booking Time')}: {moment(task.tripdate).format('LLL')}
                  </Typography>

                  <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                    <Button
                      variant="contained"
                      onClick={() => dispatch(acceptTask(task))}
                      style={{
                        flexGrow: 1,
                        textTransform: 'none',
                        backgroundColor: '#10b981',
                        color: 'white',
                        borderRadius: '8px',
                        fontWeight: 600
                      }}
                    >
                      {trans('accept_ride', 'Accept Ride')}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => dispatch(cancelTask(task.id))}
                      style={{
                        textTransform: 'none',
                        borderColor: '#ef4444',
                        color: '#ef4444',
                        borderRadius: '8px',
                        fontWeight: 600
                      }}
                    >
                      {trans('decline', 'Decline')}
                    </Button>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      )}

      {/* Control filter bar */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '16px',
        background: 'var(--bg-card)',
        padding: '16px',
        borderRadius: '16px',
        border: 'var(--card-border)',
        boxShadow: 'var(--shadow)'
      }}>
        {/* Status Filter Tabs */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {[
            { key: 'all', label: trans('all', 'All') },
            { key: 'new', label: trans('new', 'New') },
            { key: 'active', label: trans('active', 'Active') },
            { key: 'completed', label: trans('completed', 'Completed') },
            { key: 'cancelled', label: trans('cancelled', 'Cancelled') }
          ].map((tab) => (
            <Button
              key={tab.key}
              onClick={() => { setActiveTab(tab.key); setCurrentPage(1); }}
              variant={activeTab === tab.key ? 'contained' : 'text'}
              style={{
                textTransform: 'none',
                borderRadius: '8px',
                padding: '6px 16px',
                fontWeight: 600,
                fontSize: '14px',
                backgroundColor: activeTab === tab.key ? 'var(--primary)' : 'transparent',
                color: activeTab === tab.key ? 'white' : 'var(--text-secondary)',
                boxShadow: activeTab === tab.key ? '0 4px 12px rgba(72, 127, 255, 0.2)' : 'none',
              }}
            >
              {tab.label}
            </Button>
          ))}
        </div>

        {/* Search input and export button */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', width: '100%', maxWidth: '450px', marginLeft: isRTL === 'rtl' ? '0' : 'auto', marginRight: isRTL === 'rtl' ? 'auto' : '0' }}>
          <div style={{ position: 'relative', width: '100%' }}>
            <SearchIcon style={{
              position: 'absolute',
              left: isRTL === 'rtl' ? 'auto' : '12px',
              right: isRTL === 'rtl' ? '12px' : 'auto',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--text-secondary)',
              fontSize: '20px'
            }} />
            <input
              type="text"
              placeholder={t("search")}
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
              style={{
                width: '100%',
                paddingLeft: isRTL === 'rtl' ? '12px' : '40px',
                paddingRight: isRTL === 'rtl' ? '40px' : '12px',
                paddingTop: '10px',
                paddingBottom: '10px',
                borderRadius: '8px',
                border: 'var(--card-border)',
                backgroundColor: 'var(--table-input-bg)',
                color: 'var(--text-main)',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box',
                textAlign: isRTL === 'rtl' ? 'right' : 'left',
                direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
              }}
            />
          </div>
          {settings.AllowCriticalEditsAdmin && (
            <Button
              onClick={() => {
                const headerRow = [t('booking_ref'), t('booking_date'), t('car_type'), t('assign_driver'), t('booking_status_web'), t('otp'), t('trip_cost')];
                const dataRows = filteredBookings.map((row) => {
                  const formattedDate = row.bookingDate
                    ? new Date(row.bookingDate).toLocaleDateString() + " " + new Date(row.bookingDate).toLocaleTimeString()
                    : '';
                  return [
                    row.reference || '',
                    formattedDate,
                    row.carType || '',
                    row.driver_name || '',
                    row.status || '',
                    row.otp || '',
                    row.trip_cost || '0'
                  ];
                });
                const delimiter = ",";
                const csvContent = [headerRow, ...dataRows]
                  .map((e) => e.join(delimiter))
                  .join("\n");
                downloadCsv(csvContent, "bookings.csv");
              }}
              variant="outlined"
              style={{
                textTransform: 'none',
                borderColor: 'var(--border-color)',
                color: 'var(--text-main)',
                borderRadius: '8px',
                padding: '9px 16px',
                fontWeight: 600,
                whiteSpace: 'nowrap'
              }}
            >
              {t("export")}
            </Button>
          )}
        </div>
      </div>

      {/* Grid view layout */}
      {layoutMode === 'grid' ? (
        currentData.length === 0 ? (
          <div style={{
            background: 'var(--bg-card)',
            border: 'var(--card-border)',
            borderRadius: '16px',
            padding: '40px',
            textAlign: 'center',
            color: 'var(--text-secondary)',
            boxShadow: 'var(--shadow)'
          }}>
            {trans('no_bookings_found', 'No bookings found')}
          </div>
        ) : (
          <Grid container spacing={3}>
            {currentData.map((booking) => {
              const statusInfo = getStatusDetails(booking.status);
              const bookingIndex = data.findIndex(b => b.id === booking.id);
              return (
                <Grid item xs={12} sm={6} md={4} key={booking.id}>
                  <div style={{
                    background: 'var(--bg-card)',
                    border: 'var(--card-border)',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: 'var(--shadow)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100%',
                    boxSizing: 'border-box',
                    transition: 'all 0.25s ease'
                  }}>
                    <div>
                      {/* Top labels */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                        <span style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: 'white',
                          background: 'var(--primary)',
                          padding: '4px 10px',
                          borderRadius: '6px',
                          textTransform: 'uppercase'
                        }}>
                          {booking.carType}
                        </span>
                        <span style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: statusInfo.color,
                          background: statusInfo.bg,
                          padding: '4px 10px',
                          borderRadius: '6px',
                          textTransform: 'uppercase'
                        }}>
                          {statusInfo.label}
                        </span>
                      </div>
                      
                      {/* Reference & date */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <Typography style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text-main)', fontFamily: 'Outfit, sans-serif' }}>
                          #{booking.reference}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'var(--text-secondary)' }}>
                          <AccessTimeIcon style={{ fontSize: '14px' }} />
                          <Typography style={{ fontSize: '12px', fontWeight: 500 }}>
                            {booking.bookingDate ? moment(booking.bookingDate).format('lll') : ''}
                          </Typography>
                        </div>
                      </div>

                      {/* Route timeline graphic */}
                      <div style={{ display: 'flex', gap: '12px', margin: '16px 0' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                          <div style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: '#10b981',
                            border: '2px solid var(--bg-card)',
                            boxShadow: '0 0 0 2px rgba(16, 185, 129, 0.2)',
                            zIndex: 2
                          }} />
                          <div style={{
                            width: '2px',
                            flexGrow: 1,
                            backgroundColor: 'var(--border-color)',
                            margin: '4px 0',
                            zIndex: 1,
                            minHeight: '24px'
                          }} />
                          <div style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '2px',
                            backgroundColor: '#ef4444',
                            border: '2px solid var(--bg-card)',
                            boxShadow: '0 0 0 2px rgba(239, 68, 68, 0.2)',
                            zIndex: 2
                          }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '8px', flexGrow: 1 }}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: '9px', textTransform: 'uppercase', color: 'var(--text-secondary)', fontWeight: 700, letterSpacing: '0.05em' }}>
                              {trans('pickup', 'Pickup')}
                            </span>
                            <span style={{ fontSize: '13px', color: 'var(--text-main)', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical' }}>
                              {booking.pickupAddress}
                            </span>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: '9px', textTransform: 'uppercase', color: 'var(--text-secondary)', fontWeight: 700, letterSpacing: '0.05em' }}>
                              {trans('dropoff', 'Dropoff')}
                            </span>
                            <span style={{ fontSize: '13px', color: 'var(--text-main)', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical' }}>
                              {booking.dropAddress}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* OTP display */}
                      {booking.otp && ['NEW', 'ACCEPTED', 'ARRIVED', 'STARTED'].includes(booking.status) && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px 12px',
                          backgroundColor: 'rgba(72, 127, 255, 0.04)',
                          borderRadius: '8px',
                          marginBottom: '16px',
                          border: '1px dashed rgba(72, 127, 255, 0.25)'
                        }}>
                          <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 500 }}>
                            {t('otp')}
                          </span>
                          <span style={{ fontSize: '13px', color: 'var(--primary)', fontWeight: 700, letterSpacing: '0.1em' }}>
                            {booking.otp}
                          </span>
                        </div>
                      )}

                      {/* Price and Driver */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderTop: '1px solid var(--border-color)',
                        paddingTop: '16px',
                        marginTop: '16px'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {booking.driver_name ? (
                            <>
                              <Avatar
                                src={booking.driver_image}
                                style={{ width: '36px', height: '36px', border: '1px solid var(--border-color)' }}
                              />
                              <div>
                                <Typography style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-main)' }}>
                                  {booking.driver_name}
                                </Typography>
                                <Typography style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>
                                  {settings.AllowCriticalEditsAdmin ? booking.driver_contact : t('hidden_demo')}
                                </Typography>
                              </div>
                            </>
                          ) : (
                            <div>
                              <Typography style={{ fontSize: '12px', fontWeight: 500, color: 'var(--text-secondary)' }}>
                                {trans('no_driver', 'No driver assigned')}
                              </Typography>
                            </div>
                          )}
                        </div>
                        
                        <div style={{ textAlign: 'right' }}>
                          <Typography style={{ fontSize: '11px', color: 'var(--text-secondary)', fontWeight: 500 }}>
                            {t('trip_cost')}
                          </Typography>
                          <Typography style={{ fontSize: '18px', fontWeight: 700, color: 'var(--primary)' }}>
                            {booking.trip_cost
                              ? settings.swipe_symbol
                                ? booking.trip_cost + " " + settings.symbol
                                : settings.symbol + " " + booking.trip_cost
                              : settings.swipe_symbol
                                ? "0 " + settings.symbol
                                : settings.symbol + " 0"
                            }
                          </Typography>
                        </div>
                      </div>

                      {/* Customer Info (Admin / FleetAdmin perspective) */}
                      {(role === 'admin' || role === 'fleetadmin') && (
                        <div style={{
                          marginTop: '14px',
                          padding: '12px',
                          backgroundColor: 'var(--table-input-bg)',
                          borderRadius: '10px',
                          fontSize: '12px',
                          border: 'var(--card-border)'
                        }}>
                          <div style={{ color: 'var(--text-secondary)', fontWeight: 500, marginBottom: '2px' }}>
                            {trans('customer', 'Customer')}: <span style={{ color: 'var(--text-main)', fontWeight: 600 }}>{booking.customer_name}</span>
                          </div>
                          <div style={{ color: 'var(--text-secondary)' }}>
                            {settings.AllowCriticalEditsAdmin ? booking.customer_contact : t('hidden_demo')}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Action buttons footer */}
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '8px',
                      marginTop: '20px',
                      borderTop: '1px solid var(--border-color)',
                      paddingTop: '16px'
                    }}>
                      {/* Cancel Booking */}
                      {(booking.status === "NEW" || booking.status === "ACCEPTED") && (
                        <Button
                          variant="outlined"
                          onClick={() => handleCancelBooking(booking)}
                          style={{
                            flexGrow: 1,
                            textTransform: 'none',
                            borderColor: '#ef4444',
                            color: '#ef4444',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '13px'
                          }}
                        >
                          {t("cancel_booking")}
                        </Button>
                      )}

                      {/* Select Bid (Customer perspective) */}
                      {booking.status === "NEW" && role === "customer" && booking.driverOffers && (
                        <Button
                          variant="contained"
                          onClick={() => {
                            setRowIndex(bookingIndex);
                            setSelectedBooking(booking);
                            setBidModalStatus(true);
                          }}
                          style={{
                            flexGrow: 1,
                            textTransform: 'none',
                            backgroundColor: 'var(--primary)',
                            color: 'white',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '13px'
                          }}
                        >
                          {t("selectBid")}
                        </Button>
                      )}

                      {/* Assign Driver (Admin/FleetAdmin perspective) */}
                      {booking.status === "NEW" && (role === "admin" || role === "fleetadmin") && settings.autoDispatch === false && showEst && (
                        <Button
                          variant="contained"
                          onClick={() => {
                            setOpen(true);
                            setRowIndex(bookingIndex);
                          }}
                          style={{
                            flexGrow: 1,
                            textTransform: 'none',
                            backgroundColor: '#10b981',
                            color: 'white',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '13px'
                          }}
                        >
                          {t("assign_driver")}
                        </Button>
                      )}

                      {/* Pay Now (Customer perspective) */}
                      {(booking.status === "PAYMENT_PENDING" || booking.status === "PENDING") && role === "customer" && (
                        <Button
                          variant="contained"
                          onClick={() => processPayment(booking)}
                          style={{
                            flexGrow: 1,
                            textTransform: 'none',
                            backgroundColor: '#10b981',
                            color: 'white',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '13px'
                          }}
                        >
                          {t("paynow_button")}
                        </Button>
                      )}

                      {/* Force End (Admin perspective) */}
                      {booking.status === "STARTED" && role === "admin" && (
                        <Button
                          variant="contained"
                          onClick={() => dispatch(forceEndBooking(booking))}
                          style={{
                            flexGrow: 1,
                            textTransform: 'none',
                            backgroundColor: '#f59e0b',
                            color: 'white',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '13px'
                          }}
                        >
                          {t("force_end")}
                        </Button>
                      )}

                      <Button
                        variant="text"
                        onClick={() => navigate(`/bookings/bookingdetails/${booking.id}`)}
                        style={{
                          textTransform: 'none',
                          color: 'var(--primary)',
                          borderRadius: '8px',
                          fontWeight: 600,
                          fontSize: '13px',
                          marginLeft: isRTL === 'rtl' ? '0' : 'auto',
                          marginRight: isRTL === 'rtl' ? 'auto' : '0',
                          minWidth: 'auto',
                          padding: '6px 12px'
                        }}
                      >
                        {trans('details', 'Details')} &rarr;
                      </Button>
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        )
      ) : (
        /* SaaS Custom List Table View */
        <div style={{
          overflowX: 'auto',
          background: 'var(--bg-card)',
          borderRadius: '16px',
          border: 'var(--card-border)',
          boxShadow: 'var(--shadow)',
          marginBottom: '20px'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            textAlign: isRTL === 'rtl' ? 'right' : 'left',
            fontSize: '14px'
          }}>
            <thead>
              <tr style={{
                background: 'var(--table-header-bg)',
                borderBottom: 'var(--card-border)'
              }}>
                {[
                  t('booking_ref'),
                  t('booking_date'),
                  t('car_type'),
                  (role === 'admin' || role === 'fleetadmin') ? trans('customer', 'Customer') : null,
                  t('assign_driver'),
                  t('booking_status_web'),
                  t('otp'),
                  t('trip_cost'),
                  trans('actions', 'Actions')
                ].filter(Boolean).map((header, index) => (
                  <th key={index} style={{
                    padding: '16px 20px',
                    fontWeight: 700,
                    color: 'var(--text-light)',
                    fontSize: '12px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan={10} style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>
                    {trans('no_bookings_found', 'No bookings found')}
                  </td>
                </tr>
              ) : (
                currentData.map((booking) => {
                  const statusInfo = getStatusDetails(booking.status);
                  const bookingIndex = data.findIndex(b => b.id === booking.id);
                  return (
                    <tr
                      key={booking.id}
                      style={{
                        borderBottom: 'var(--table-border)',
                        backgroundColor: 'var(--table-row-bg)',
                        transition: 'background-color 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--table-row-selected)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--table-row-bg)';
                      }}
                    >
                      {/* Ref */}
                      <td style={{ padding: '16px 20px', fontWeight: 700, color: 'var(--text-main)' }}>
                        #{booking.reference}
                      </td>
                      
                      {/* Date */}
                      <td style={{ padding: '16px 20px', color: 'var(--text-main)', whiteSpace: 'nowrap' }}>
                        {booking.bookingDate ? moment(booking.bookingDate).format('lll') : ''}
                      </td>
                      
                      {/* Car Type */}
                      <td style={{ padding: '16px 20px', color: 'var(--text-main)', fontWeight: 500 }}>
                        {booking.carType}
                      </td>

                      {/* Customer Info (Admin / FleetAdmin only) */}
                      {(role === 'admin' || role === 'fleetadmin') && (
                        <td style={{ padding: '16px 20px' }}>
                          <div style={{ fontWeight: 600, color: 'var(--text-main)' }}>{booking.customer_name}</div>
                          <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>
                            {settings.AllowCriticalEditsAdmin ? booking.customer_contact : t('hidden_demo')}
                          </div>
                        </td>
                      )}

                      {/* Driver */}
                      <td style={{ padding: '16px 20px' }}>
                        {booking.driver_name ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Avatar src={booking.driver_image} style={{ width: '28px', height: '28px', border: '1px solid var(--border-color)' }} />
                            <div>
                              <div style={{ fontWeight: 600, color: 'var(--text-main)', fontSize: '13px' }}>{booking.driver_name}</div>
                              <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>
                                {settings.AllowCriticalEditsAdmin ? booking.driver_contact : t('hidden_demo')}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <span style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>{trans('no_driver', 'Unassigned')}</span>
                        )}
                      </td>

                      {/* Status */}
                      <td style={{ padding: '16px 20px' }}>
                        <span style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: statusInfo.color,
                          backgroundColor: statusInfo.bg,
                          padding: '6px 12px',
                          borderRadius: '6px',
                          display: 'inline-block',
                          textTransform: 'uppercase',
                          textAlign: 'center',
                          minWidth: '95px'
                        }}>
                          {statusInfo.label}
                        </span>
                      </td>

                      {/* OTP */}
                      <td style={{ padding: '16px 20px', color: 'var(--primary)', fontWeight: 700, letterSpacing: '0.05em' }}>
                        {booking.otp && ['NEW', 'ACCEPTED', 'ARRIVED', 'STARTED'].includes(booking.status) ? booking.otp : '-'}
                      </td>

                      {/* Cost */}
                      <td style={{ padding: '16px 20px', fontWeight: 700, color: 'var(--text-main)' }}>
                        {booking.trip_cost
                          ? settings.swipe_symbol
                            ? booking.trip_cost + " " + settings.symbol
                            : settings.symbol + " " + booking.trip_cost
                          : settings.swipe_symbol
                            ? "0 " + settings.symbol
                            : settings.symbol + " 0"
                        }
                      </td>

                      {/* Actions */}
                      <td style={{ padding: '16px 20px' }}>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          {/* Cancel Booking */}
                          {(booking.status === "NEW" || booking.status === "ACCEPTED") && (
                            <Button
                              variant="outlined"
                              onClick={() => handleCancelBooking(booking)}
                              style={{
                                textTransform: 'none',
                                borderColor: '#ef4444',
                                color: '#ef4444',
                                borderRadius: '6px',
                                padding: '4px 10px',
                                fontSize: '12px',
                                fontWeight: 600
                              }}
                            >
                              {t("cancel_booking")}
                            </Button>
                          )}

                          {/* Select Bid */}
                          {booking.status === "NEW" && role === "customer" && booking.driverOffers && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setRowIndex(bookingIndex);
                                setSelectedBooking(booking);
                                setBidModalStatus(true);
                              }}
                              style={{
                                textTransform: 'none',
                                backgroundColor: 'var(--primary)',
                                color: 'white',
                                borderRadius: '6px',
                                padding: '4px 10px',
                                fontSize: '12px',
                                fontWeight: 600
                              }}
                            >
                              {t("selectBid")}
                            </Button>
                          )}

                          {/* Assign Driver */}
                          {booking.status === "NEW" && (role === "admin" || role === "fleetadmin") && settings.autoDispatch === false && showEst && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setOpen(true);
                                setRowIndex(bookingIndex);
                              }}
                              style={{
                                textTransform: 'none',
                                backgroundColor: '#10b981',
                                color: 'white',
                                borderRadius: '6px',
                                padding: '4px 10px',
                                fontSize: '12px',
                                fontWeight: 600
                              }}
                            >
                              {t("assign_driver")}
                            </Button>
                          )}

                          {/* Pay Now */}
                          {(booking.status === "PAYMENT_PENDING" || booking.status === "PENDING") && role === "customer" && (
                            <Button
                              variant="contained"
                              onClick={() => processPayment(booking)}
                              style={{
                                textTransform: 'none',
                                backgroundColor: '#10b981',
                                color: 'white',
                                borderRadius: '6px',
                                padding: '4px 10px',
                                fontSize: '12px',
                                fontWeight: 600
                              }}
                            >
                              {t("paynow_button")}
                            </Button>
                          )}

                          {/* Force End */}
                          {booking.status === "STARTED" && role === "admin" && (
                            <Button
                              variant="contained"
                              onClick={() => dispatch(forceEndBooking(booking))}
                              style={{
                                textTransform: 'none',
                                backgroundColor: '#f59e0b',
                                color: 'white',
                                borderRadius: '6px',
                                padding: '4px 10px',
                                fontSize: '12px',
                                fontWeight: 600
                              }}
                            >
                              {t("force_end")}
                            </Button>
                          )}

                          <Button
                            onClick={() => navigate(`/bookings/bookingdetails/${booking.id}`)}
                            style={{
                              minWidth: 'auto',
                              padding: '4px 8px',
                              color: 'var(--primary)',
                              fontWeight: 600,
                              textTransform: 'none',
                              fontSize: '12px'
                            }}
                          >
                            {trans('view', 'View')}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )
      }

      {/* Pagination controls */}
      {filteredBookings.length > 0 && (
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          padding: '16px',
          background: 'var(--bg-card)',
          borderRadius: '16px',
          border: 'var(--card-border)',
          boxShadow: 'var(--shadow)',
          color: 'var(--text-main)',
          fontSize: '14px',
          marginTop: '20px'
        }}>
          <div>
            {trans('showing', 'Showing')}{' '}
            <span style={{ fontWeight: 600 }}>{(currentPage - 1) * pageSize + 1}</span>{' '}
            {trans('to', 'to')}{' '}
            <span style={{ fontWeight: 600 }}>{Math.min(currentPage * pageSize, filteredBookings.length)}</span>{' '}
            {trans('of', 'of')}{' '}
            <span style={{ fontWeight: 600 }}>{filteredBookings.length}</span>{' '}
            {trans('entries', 'entries')}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{trans('rows_per_page', 'Rows per page')}:</span>
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{
                  padding: isRTL === 'rtl' ? '6px 12px 6px 32px' : '6px 32px 6px 12px',
                  borderRadius: '8px',
                  border: 'var(--card-border)',
                  backgroundColor: 'var(--table-input-bg)',
                  color: 'var(--text-main)',
                  outline: 'none',
                  fontSize: '13px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  minWidth: '75px',
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: isRTL === 'rtl' ? 'left 10px center' : 'right 10px center',
                  backgroundSize: '14px'
                }}
              >
                {[10, 15, 20].map((size) => (
                  <option key={size} value={size} style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-main)' }}>
                    {size}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: 'flex', gap: '6px' }}>
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                variant="outlined"
                style={{
                  textTransform: 'none',
                  borderColor: 'var(--border-color)',
                  color: currentPage === 1 ? 'var(--text-secondary)' : 'var(--text-main)',
                  borderRadius: '8px',
                  padding: '6px 10px',
                  fontWeight: 600,
                  minWidth: 'auto'
                }}
              >
                <ChevronLeftIcon style={{ fontSize: '18px' }} />
              </Button>
              {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => {
                if (
                  page === 1 ||
                  page === totalPages ||
                  Math.abs(page - currentPage) <= 1
                ) {
                  return (
                    <Button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      variant={currentPage === page ? 'contained' : 'outlined'}
                      style={{
                        textTransform: 'none',
                        backgroundColor: currentPage === page ? 'var(--primary)' : 'transparent',
                        color: currentPage === page ? 'white' : 'var(--text-main)',
                        borderColor: currentPage === page ? 'var(--primary)' : 'var(--border-color)',
                        borderRadius: '8px',
                        minWidth: '36px',
                        height: '36px',
                        padding: 0,
                        fontWeight: 600,
                        fontSize: '13px'
                      }}
                    >
                      {page}
                    </Button>
                  );
                } else if (
                  (page === 2 && currentPage > 3) ||
                  (page === totalPages - 1 && currentPage < totalPages - 2)
                ) {
                  return (
                    <span key={page} style={{ alignSelf: 'center', color: 'var(--text-secondary)', padding: '0 4px' }}>
                      ...
                    </span>
                  );
                }
                return null;
              })}
              <Button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                variant="outlined"
                style={{
                  textTransform: 'none',
                  borderColor: 'var(--border-color)',
                  color: currentPage === totalPages ? 'var(--text-secondary)' : 'var(--text-main)',
                  borderRadius: '8px',
                  padding: '6px 10px',
                  fontWeight: 600,
                  minWidth: 'auto'
                }}
              >
                <ChevronRightIcon style={{ fontSize: '18px' }} />
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Modals section */}
      <BidModal
        ref={rootRef.current}
        role={role}
        selectedBooking={selectedBooking}
        bidModalStatus={bidModalStatus}
        handleBidModalClose={handleBidModalClose}
        classes={classes}
        settings={settings}
        acceptBid={() => {
          const bookingObj = acceptBid(selectedBooking, selectedBidder);
          processPayment(bookingObj);
          handleBidModalClose();
        }}
        selectedBidder={selectedBidder}
        handleChange={handleChange}
      />

      {selectedBooking &&
        selectedBooking.payment_mode === "wallet" &&
        (selectedBooking.status === "PENDING" ||
          (selectedBooking &&
            selectedBooking.selectedBid &&
            selectedBooking.status === "NEW")) &&
        role === "customer" ? (
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={walletModalStatus}
          onClose={handleWalletModalClose}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <Grid container spacing={2} className={classes.paper}>
            <Grid
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Typography style={{ fontWeight: "bolder", marginBottom: 10, fontSize: '20px', fontFamily: 'Outfit, sans-serif' }}>
                {t("payment")}
              </Typography>
              {selectedBooking ? (
                <Typography color={"primary"} style={{ fontSize: 32, fontWeight: 700, margin: '12px 0' }}>
                  {settings.swipe_symbol === false
                    ? settings.symbol + selectedBooking.trip_cost
                    : selectedBooking.trip_cost + settings.symbol}
                </Typography>
              ) : null}
              <Typography style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                {t("use_wallet_balance") +
                  " (" +
                  (settings.swipe_symbol === false
                    ? settings.symbol + auth.profile.walletBalance
                    : auth.profile.walletBalance + settings.symbol) +
                  ")"}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', gap: '10px' }}>
              <Button
                onClick={handleWalletModalClose}
                variant="outlined"
                style={{
                  textTransform: 'none',
                  borderColor: 'var(--border-color)',
                  color: 'var(--text-main)',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontWeight: 600
                }}
              >
                {t("cancel")}
              </Button>
              <Button
                variant="contained"
                style={{
                  textTransform: 'none',
                  backgroundColor: 'var(--primary)',
                  color: 'white',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontWeight: 600
                }}
                onClick={handleWalletPayment}
              >
                {t("paynow_button")}
              </Button>
            </Grid>
          </Grid>
        </Modal>
      ) : null}

      {selectedBooking &&
        selectedBooking.paymentPacket &&
        selectedBooking.payment_mode === "card" &&
        ((selectedBooking.status === "PENDING" || selectedBooking.status === "PAYMENT_PENDING") ||
          (selectedBooking &&
            selectedBooking.selectedBid &&
            selectedBooking.status === "NEW")) &&
        role === "customer" ? (
        <PaymentGatewayModal
          open={paymentModalStatus}
          onClose={handlePaymentModalClose}
          orderId={selectedBooking.id}
          amount={
            selectedBooking.selectedBid
              ? selectedBooking.selectedBid.trip_cost
              : selectedBooking.trip_cost
          }
          currency={settings?.code}
          productName={t("bookingPayment")}
          booking={selectedBooking}
        />
      ) : null}

      <ConfirmationDialogRaw
        open={openConfirm}
        onClose={onConfirmClose}
        value={""}
      />

      {users && data && rowIndex >= 0 ? (
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          onClose={handleClose}
          open={open}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <div className={classes.paper}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h5"
                  style={{
                    fontWeight: 700,
                    color: 'var(--text-main)',
                    fontFamily: 'Outfit, sans-serif',
                    textAlign: isRTL === "rtl" ? "right" : "left"
                  }}
                >
                  {t("select_driver")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <UsersCombo
                  placeholder={t("select_user")}
                  users={users.filter(
                    (usr) => usr.carType === data[rowIndex].carType
                  )}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                  marginTop: '16px'
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  style={{
                    textTransform: 'none',
                    borderColor: 'var(--border-color)',
                    color: 'var(--text-main)',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontWeight: 600
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={assignDriver}
                  variant="contained"
                  style={{
                    textTransform: 'none',
                    backgroundColor: 'var(--primary)',
                    color: 'white',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontWeight: 600
                  }}
                >
                  {t("assign")}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Modal>
      ) : null}

      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
};

export default BookingHistory;
